import type { EventZaloBotDto } from '@rw/shared';
import { api } from '../../lib/api';

/** Saves a Zalo bot on an event (from the event page, or right after creating the event). */
export const saveZaloBot = (eventId: string, token: string) => api<EventZaloBotDto>(`/competitions/${eventId}/zalo`, { method: 'PUT', body: { token } });
